import { api } from '@/shared/lib/api'
import type { QrResolution } from '@/shared/lib/qr-resolver/resolveQrCode'

export type CheckInFromQrResolutionResult = 'done' | 'failed' | 'skipped'

// Envelope de `respond_with_serialized_record` (api/app/controllers/base_controller.rb:65):
// o corpo vem sempre dentro de `record`, nunca solto em `data`.
type FinishResourceResponse = {
  record?: {
    finished_partners?: unknown
  }
}

// Registra o check-in do Parceiro no instante da leitura do QR, antes da
// navegação. Nunca lança: falha de rede vira `failed`, e a navegação que
// espera por esta função não pode ficar refém dela.
//
// A classificação é pela resposta, não pela ausência de exceção —
// `finish_resource_service.rb:294` responde `200` mesmo quando não registra
// (Parceiro desativado), então só `finished_partners` conter o id prova o
// registro.
export const checkInFromQrResolution = async (
  resolution: QrResolution,
  eventSlug: string
): Promise<CheckInFromQrResolutionResult> => {
  if (resolution.status !== 'resolved') return 'skipped'
  if (resolution.resourceType !== 'Partner') return 'skipped'

  const partnerId = resolution.resource.id
  if (typeof partnerId !== 'number') return 'skipped'

  // `useDigitalProductContextOptional` devolve `null` fora do provider, e o
  // projeto não liga `strictNullChecks` — sem esta guarda o slug ausente vira
  // `POST /user/digital_products/undefined/...`, 404, e um toast de erro numa
  // cena em que nenhum check-in era possível.
  if (!eventSlug) return 'skipped'

  let data: FinishResourceResponse

  try {
    ;({ data } = await api.post(
      `/user/digital_products/${eventSlug}/progress/finish_resource`,
      { record: { resource_id: partnerId, resource_type: 'Partner' } }
    ))
  } catch {
    return 'failed'
  }

  const finishedPartners = data?.record?.finished_partners

  return Array.isArray(finishedPartners) && finishedPartners.includes(partnerId)
    ? 'done'
    : 'failed'
}
